module.exports = __webpack_public_path__ + "static/media/subscribe-thumnail.55ef35e8.png";